<template>
  <v-btn
    v-if="!buttonDisabled"
    elevation="0"
    outlined
    color="secondary"
    class="h-full pr-1 btn action-button"
    :class="$style.notificationButton"
    :title="$t('contact.formLinkTitle')"
    @click="openDialog = !openDialog"
  >
    <span class="mdi mdi-check" :class="$style.buttonIcon"></span>

    <span :class="$style.notificationButtonText">
      {{ $t('form.confirmText.confirm') }}
    </span>
    <BackorderEditDialog
      :open="openDialog"
      :context-brand="contextBrand"
      @hide-dialog="openDialog = false"
      @all-company-codes-in-queue="toggleButton"
    />
  </v-btn>
</template>

<script>
import BackorderEditDialog from '../shared/BackorderEditDialog'

export default {
  name: 'ConfirmBackorderEditButton',
  components: { BackorderEditDialog },
  props: {
    contextBrand: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      openDialog: false,
      buttonDisabled: false,
    }
  },
  methods: {
    toggleDialog() {
      this.openDialog = false
    },
    toggleButton(isEqual) {
      this.buttonDisabled = isEqual
    },
  },
}
</script>
<style lang="scss" module>
.notificationButton {
  @media screen and (max-width: map-get($grid-breakpoints, 'md')) {
    align-self: flex-start;
    order: 1;
    margin: {
      bottom: 1rem;
      left: 0;
    }
  }
}

.buttonIcon {
  @media screen and (max-width: map-get($grid-breakpoints, 'md')) {
    font-size: 1.1rem;
  }
  font-size: 1.25rem;
}

.notificationButton {
  margin-left: 0.5rem;
  padding: 0.125rem !important;
}

.notificationButtonText {
  margin-left: 0.125rem;

  font-weight: normal;
  font-size: 14px;
}
</style>
